const accountSettings = {
    title: 'Account Settings',
    personalDataTab: {
        title: 'Personal Data',
        inputs: {
            name: 'First Name',
            surname: 'Last Name',
            companyName: 'Company Name',
            nip: 'Tax ID'
        }
    },
    passwordsTab: {
        title: 'Passwords',
        inputs: {
            oldPassword: 'Current Password',
            newPassword: 'New Password',
            confirmNewPassword: 'Confirm New Password'
        },
        errors: {
            newPasswordNotRepeatedCorrectly: 'The new password and its confirmation do not match'
        }
    },
    emailTab: {
        title: 'Email',
        inputs: {
            email: 'Email'
        },
        submitSucceeded: 'Confirmation email has been sent to your current email address. Please log in to confirm the change. If you do not receive the email within 2 hours, please contact the Administrator.'
    },
    changeEmailConfirm: {
        pending: {
            title: 'Confirming email change',
            description: 'Confirming email change. Please wait...',
        },
        success: {
            title: 'Email address has been changed',
            description: 'The email address change has been confirmed.',
        },
        error: {
            title: 'Failed to confirm change',
            description: 'The token is invalid, expired, or a server error occurred.',
        },
        missingToken: {
            title: 'Invalid link',
            description: 'The link is missing the token required to confirm the email address change.',
        },
        backToAccountSettings: 'Back to account settings',
    }
};

export default accountSettings;